import {
    CREATEROLEMAPPING_SUCCESS,
    CREATEROLEMAPPING_FAILED,
    RESET_CREATEROLEMAPPING,
    LOADING_CREATEROLEMAPPING,
    NETWORK_ERROR_CREATEROLEMAPPING,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_CREATEROLEMAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case CREATEROLEMAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case CREATEROLEMAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_CREATEROLEMAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_CREATEROLEMAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
